module.exports = __webpack_public_path__ + "media/Puck-by-Qrespi-Introduction-v22.257830cc.webm";